/**
 * Factory that creates a breakpoint-reading function bound to a live store.
 *
 * The returned function reads the latest state on every call, so it always
 * reflects the current viewport breakpoint rather than a value captured at
 * construction time.
 *
 * Prefer this over `createDesktopChecker` when you need the raw breakpoint
 * value — e.g. inside a reactive `map(() => getBreakpoint()), distinctUntilChanged()`
 * pipeline, or when comparing against a specific non-desktop breakpoint.
 *
 * @module searchResultsMap/services/createBreakpointChecker
 */

import { selectLayoutBreakpoint } from 'layout/redux/selectors';

/**
 * @param {Function} getState - Redux store.getState
 * @returns {() => import('layout/enums/layoutBreakpoint').default}
 */
export default function createBreakpointChecker(getState) {
  return function getBreakpoint() {
    return selectLayoutBreakpoint(getState());
  };
}
